import moment from "moment"

const PT_LABELS = {
  days: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
  months: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
  monthsShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
  today: "Hoje",
  now: "Agora",
  am: "AM",
  pm: "PM",
}

let CALENDAR_SETTINGS = {
  type: "date",
  firstDayOfWeek: 1,
  today: true,
  monthFirst: false,
  touchReadonly: false,
  text: PT_LABELS,
  formatter: {
    date: (date, settings) => moment(date).format("DD/MM/YYYY"),
  },
}

export default class Calendar {

  static init(id, settings) {

    let data = { ...CALENDAR_SETTINGS, ...settings }

    data.text = PT_LABELS

    $(id).calendar(data)

    $(".date").prop("type", "tel")
    $(".date").mask("00/00/0000")
  }

  static initInputs() {

    let data = CALENDAR_SETTINGS

    data.text = PT_LABELS

    $(".ui.calendar").calendar(data)

    $(".date").prop("type", "tel")    
    $(".date").mask("00/00/0000")
  }

  static labelOfWeek(day) {

    if (!day)
      return ""

    const key = parseInt(day)

    if (key < 0 || key > 6)
      return ""

    const days = {
      "0": "domingo",
      "1": "segunda",
      "2": "terça",
      "3": "quarta",
      "4": "quinta",
      "5": "sexta",
      "6": "sábado",
    }

    return days[key]
  }
}
